module.exports = __webpack_public_path__ + "static/img/3.7a1e99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/profile/3.png
// module id = /2fl
// module chunks = 1